import Vue from 'vue';
import { detectEnv } from '@/shared/detect';
import SATracking from '@/shared/saTracking';
import type VueRouter from 'vue-router';
import { useUserStore } from '@/stores/modules/user';
import { useUTMStore } from '@/stores/modules/utm';
import type { Pinia } from 'pinia';

/**
 * 设置神策埋点全局属性
 */
export function setupRegisterPageGuard(router: VueRouter, pinia: Pinia) {
  const userStore = useUserStore(pinia);
  const utmStore = useUTMStore(pinia);

  router.beforeEach((to, from, next) => {
    let platform = 'web';

    if (detectEnv.yxh) {
      if (detectEnv.ios) {
        platform = 'ios';
      }

      if (detectEnv.android) {
        platform = 'android';
      }

      if (detectEnv.harmony) {
        platform = 'harmony';
      }
    }

    // 先清除下页面中可能注册的全局埋点属性
    SATracking.clearPageRegister();

    // 设置埋点全局参数
    SATracking.registerPage({
      utm_source: to.query.utm_source ?? utmStore.source,
      process_type: userStore.isTelemarketing ? 'dx_sms_link' : '',
      platform_type: platform,
      is_login: userStore.isLogin,
      bu: 'yxh',
      referrer: window.__vue_router_referrer__,
    });

    next();
  });
}

/**
 * 神策默认PV埋点
 * 不使用is_track_single_page是因为统计到的title是变更前的
 */
export function trackPageViewGuard(router: VueRouter) {
  router.afterEach((to) => {
    Vue.nextTick(() => {
      if (!to.meta?.excludeTracking) {
        SATracking.trackPageView();
      }
    });
  });
}
